import Vue from 'vue'
import Router from 'vue-router'
import Footer from './views/Footer.vue'
import Header from './views/Header.vue'
import Home from './views/Home.vue'
import HomeImage from './views/Home/HomeImage.vue'
import HomeBody from './views/Home/HomeBody.vue'
import AboutUs from './views/AboutUs/AboutUs.vue'
import Products from './views/Products/Products.vue'
import ProductType from './views/Products/ProductType.vue'
import ProductDetail from './views/Products/ProductDetail.vue'
import ContactUs from './views/ContactUs/ContactUs.vue'
import Service from './views/Service/Service.vue'
import News from './views/News/News.vue'
import NewsDetail from './views/News/NewsDetail.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,

        },
        {
            path: '/footer',
            name: 'Footer',
            component: Footer
        },
        {
            path: '/header',
            name: 'Header',
            component: Header
        },
        {
            path: '/homeImage',
            name: 'HomeImage',
            component: HomeImage
        },
        {
            path: '/homeBody',
            name: 'HomeBody',
            component: HomeBody
        },
        {
            path: '/aboutUs',
            name: 'AboutUs',
            component: AboutUs
        },
        {
            path: '/products',
            name: 'Products',
            component: Products
        },
        {
            path: '/products/:categoryRouter',
            name: 'ProductType',
            component: ProductType
        },
        {
            path: '/products/:categoryRouter/:productId',
            name: 'ProductDetail',
            component: ProductDetail
        },
        {
            path: '/contactUs',
            name: 'ContactUs',
            component: ContactUs
        },
        {
            path: '/service',
            name: 'Service',
            component: Service
        },
        {
            path: '/news',
            name: 'News',
            component: News,
        },
        {
            path: '/news/:newsId',
            name: 'NewsDetail',
            component: NewsDetail,
        }
    ]
})
